module.exports = __webpack_public_path__ + "img/menu-hair-13.02614c8a.jpg";